import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams, useNavigate, redirect } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import Swal from "sweetalert2";


const Show = () => {
  const [receiveData, setReceiveData] = useState([]);
  const { id } = useParams();
  const [alert, setAlert] = useState(null);
  const location = useLocation();
  const [role, setRole] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    DatatableFunc();
  }, []);

  const fetchData = async () => {
    const resRole = await Http.get(`/staff-type-check`);
    setRole(resRole.data);
    Http.get("/requisition-production/" + id).then((res) => {
      setReceiveData(res.data);
    });
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);
  const approveRequisition = (id) => {
    if (role !== "gm") { return; }
    Swal.fire({
      title: "Are you sure?",
      text: "You want to approve this requisition production?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, approve it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.post("/approve-requisition-production/" + id).then((res) => {
          setReceiveData(res.data);
          Swal.fire("Approved!", "Requisition Production has been approved.", "success");
          navigate('/requisition-production');

        });
      }
    });
  };
  const receiveItem = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, receive it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.post("/receive-requisition-production/" + id).then((res) => {
          setReceiveData(res.data);
          Swal.fire("Received!", "Item has been received.", "success");
        });
      }
    });
  };
  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Requisition Production</h5>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />
            <div className="card pd-20 pd-sm-40">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12 padding">
                <div className="card">
                  <div className="card-body">
                    <div className="row mb-4">
                      <div className="col-sm-12">
                        <h5 className="mb-3">Requisition Production:</h5>
                        <div>Date :{receiveData.date}</div>
                        <div>Time :{receiveData.time}</div>
                        {/* <div>
                          Finished Good :
                          {receiveData.product ? receiveData.product.name : ""}
                        </div> */}
                        <div>Req. No. :{receiveData.batch_no}</div>
                        {/* <div>Batch Size :{receiveData.batch_size}</div> */}

                        <div>
                          Created By :
                          {receiveData.created_by
                            ? receiveData.created_by.name
                            : ""}
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive-sm">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th className="center">#</th>
                            <th>Product</th>
                            <th className="text-right">Qty</th>
                          </tr>
                        </thead>
                        <tbody>
                          {receiveData.items
                            ? receiveData.items.map((item, index) => (
                              <>
                                <tr key={item.id}>
                                  <td className="center">{index + 1}</td>
                                  <td className="left strong">
                                    {item.product ? item.product.name : ""}
                                  </td>
                                  <td className="text-right">{item.qty}</td>

                                </tr>
                              </>
                            ))
                            : ""}
                        </tbody>
                      </table>
                      {!receiveData.approved_by && role === "gm" && (
                        <span
                          className="badge bg-success p-2 rounded ms-1 text-center cursor-pointer"
                          role="button"
                          onClick={() => approveRequisition(id)}
                        >
                          Approve
                        </span>
                      )}
                      {role == 'production' && receiveData.issue && receiveData.issue.rmpm_receive_status !== 1 && (
                        <span
                          onClick={() => receiveItem(id)}
                          className="badge bg-primary p-2 rounded ms-1 cursor-pointer"
                          role="button"
                        >
                          Click to Confirm Received
                        </span>
                      )}
                      {role === 'supply_chain' && receiveData.approved_by && !receiveData.issue && (
                        <div className="row mt-3">
                          <div className="col-3">
                            
                            <Link className="btn btn-primary btn-block mg-b-10" to={{
                              pathname: "/create-issue/" + id,
                            }}>
                              <i className="fa fa-send mg-r-10"></i> Go To Release Screen
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Show;
